const getGroupSubmissionsObj = (submissions: any[]) =>
  submissions.reduce((acc, submission) => {
    const { group, receivedAt = '', displayGrade: userGrade = '' } = submission;

    if (!acc[group.id]) {
      acc[group.id] = {
        name: group.name,
        receivedAt,
        displayGrade: userGrade,
        submissions: [submission],
        ...(submission.id && { id: submission.id }),
      };
    } else {
      const { receivedAt: dateReceived, displayGrade: groupGrade } =
        acc[group.id];
      acc[group.id] = {
        ...acc[group.id],
        receivedAt: dateReceived || receivedAt,
        displayGrade: groupGrade !== userGrade ? '(Mixed)' : userGrade,
        submissions: [...acc[group.id].submissions, submission],
      };
    }

    return acc;
  }, {});

export const formatGroupSubmissions = (submissions: any[]) => {
  const submissionsObj = getGroupSubmissionsObj(submissions);
  return Object.keys(submissionsObj).map((group) => ({
    ...submissionsObj[group],
  }));
};

export const formatUnassignedStudents = (students: any[] = []) =>
  students
    .filter((student) => student?.id || student?.objectId)
    .map((student) => ({
      user: {
        avatar: student.avatar,
        firstName: student.firstName,
        id: student.id || student.objectId,
        lastName: student.lastName,
      },
    }));

export const groupSubmissionsByDate = (
  submissionsData: any[],
  dueDate: string = ''
) => {
  const earlySubmissions: any[] = [];
  const lateSubmissions: any[] = [];
  const noSubmissions: any[] = [];

  if (
    !submissionsData ||
    submissionsData.length === 0 ||
    !dueDate ||
    dueDate === ''
  )
    return { earlySubmissions, lateSubmissions, noSubmissions };

  submissionsData?.map((submission: any) => {
    if (!submission.id) {
      return noSubmissions.push(submission);
    }
    if (new Date(submission.receivedAt) <= new Date(dueDate)) {
      return earlySubmissions.push(submission);
    }

    return lateSubmissions.push(submission);
  });

  return { earlySubmissions, lateSubmissions, noSubmissions };
};
